import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["fields", "reset"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatLanguageCode } from 'i18n/options';
import getBlobDuration from 'get-blob-duration';
import { NewFileModal, ReplaceFileModal } from 'components/UploadFileModals';
import { AssetDetailsModal, UploadProgressModal, ConfirmationModal } from 'screens/ContentEditorModals';
import { useAssetEditorForm } from 'screens/ContentEditorModals/editorForms';
import { VIEWS } from './constants';
import { getAssetContentType } from './utils';
import useCallbackRef from 'hooks/useCallbackRef';
import { useUploadFile, useFetchFileStatus, FILE_STATUS_VALUES } from 'actions/file';
import { useCreateDraftAsset, useDeleteAsset, useUpdateAssets } from 'actions/assets';
import filterObject from 'utils/filterObject';
import humanFileSize from 'utils/asset/getHumanFileSize';
import getAssetType from 'utils/asset/getAssetType';
import { FILE_FORMATS, CONTENT_TYPES, IFRAME_CONTENT_TYPES } from 'utils/asset/constants';
import removeFileType from 'utils/file/removeFileType';
import { ASSET_WRITE, getIsAssetEditableInHub, hasPrivilege } from 'utils/privileges';
import { formatAssetEditorPayloadForApi } from './formatAssetEditorPayloadForApi';
import { useAiSuggestions } from './useAiSuggestions';
var fileFormatsWithDuration = [FILE_FORMATS.AUDIO, FILE_FORMATS.VIDEO];
function AssetEditor(_ref) {
  var _modals;
  var asset = _ref.asset,
    parentPlaylist = _ref.parentPlaylist,
    onSubmit = _ref.onSubmit,
    _onClose = _ref.onClose,
    onSelectAsset = _ref.onSelectAsset,
    _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager;
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.i18n;
  var isEditMode = Boolean(asset);
  var canUserSelectAsset = parentPlaylist ? getIsAssetEditableInHub({
    ownerTeamId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.ownerTeamId,
    domain_id: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.domain_id
  }) : false;
  var _useState = useState(isEditMode ?
    // When attempting to edit an asset which has a processing error, directly open the replace file modal
    (asset === null || asset === void 0 ? void 0 : asset.fileStatus) === FILE_STATUS_VALUES.INVALID ? VIEWS.REPLACE : VIEWS.DETAILS : VIEWS.UPLOAD),
    _useState2 = _slicedToArray(_useState, 2),
    view = _useState2[0],
    setView = _useState2[1];

  // TODO: Document what this state is needed for.
  // Why aren't we using `useForm` or more granular state? It's unclear when
  // `content` should be used over `asset`
  var _useState3 = useState(asset ? _objectSpread(_objectSpread({}, asset), {}, {
      fileName: asset.original_file_name || '',
      size: asset.fileSize ? humanFileSize(asset.fileSize) : undefined,
      lastUpdated: asset.lastUpdated ? Date.parse(asset.lastUpdated) : undefined
    }) : null),
    _useState4 = _slicedToArray(_useState3, 2),
    content = _useState4[0],
    setContent = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasFileStatusResolved = _useState6[0],
    setHasFileStatusResolved = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    fileUploadProgress = _useState8[0],
    setFileUploadProgress = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isReplacingFile = _useState10[0],
    setIsReplacingFile = _useState10[1];
  // We do not show the upload progress if we are editing an asset and have not added a new file
  var _useState11 = useState(!isEditMode),
    _useState12 = _slicedToArray(_useState11, 2),
    isNewFile = _useState12[0],
    setIsNewFile = _useState12[1];
  // Get asset content type which we use to determine the required type of add / edit details modal
  var assetContentType = getAssetContentType({
    type: content === null || content === void 0 ? void 0 : content.type,
    fileFormat: content === null || content === void 0 ? void 0 : content.fileFormat
  });
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isProgressViewTriggered = _useState14[0],
    setIsProgressViewTriggered = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isLoadingDuration = _useState16[0],
    setIsLoadingDuration = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isSubmissionLoading = _useState18[0],
    setIsSubmissionLoading = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    shouldAttemptSubmission = _useState20[0],
    setShouldAttemptSubmission = _useState20[1];
  var isUploadInProgress = fileUploadProgress !== undefined ? Number(fileUploadProgress) < 100 : false;
  var defaultLocale = (content === null || content === void 0 ? void 0 : content.locale) || (parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.locale) || formatLanguageCode(i18n.language) || null;
  var _useUploadFile = useUploadFile({
      onSetAlert: function onSetAlert(options) {
        setFileUploadProgress(options.progress || 0);
      }
    }),
    isUploadError = _useUploadFile.isError,
    uploadFile = _useUploadFile.uploadFile;
  var _useCreateDraftAsset = useCreateDraftAsset({
      parentPlaylistId: (parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id) || null
    }),
    isCreating = _useCreateDraftAsset.isLoading,
    createDraftAsset = _useCreateDraftAsset.createDraftAsset;
  var _useDeleteAsset = useDeleteAsset({
      assetId: (content === null || content === void 0 ? void 0 : content.id) || '',
      parentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
      hasSuccessAlert: view !== VIEWS.CONFIRMATION
    }),
    isDeleting = _useDeleteAsset.isLoading,
    softDeleteAsset = _useDeleteAsset.deleteAsset;
  var _useAiSuggestions = useAiSuggestions(),
    aiSuggestions = _useAiSuggestions.aiSuggestions,
    analyseResource = _useAiSuggestions.analyseResource;
  var _useAssetEditorForm = useAssetEditorForm({
      content: content,
      aiSuggestions: aiSuggestions,
      defaultLocale: defaultLocale
    }),
    fields = _useAssetEditorForm.fields,
    resetAssetEditorForm = _useAssetEditorForm.reset,
    form = _objectWithoutProperties(_useAssetEditorForm, _excluded);
  useEffect(function () {
    // When our AI suggestions have been loaded, soft-reload the form
    // to populate empty fields.
    if (aiSuggestions) {
      resetAssetEditorForm({
        keepUserValues: true
      });
    }
  }, [aiSuggestions, resetAssetEditorForm]);
  var isChangedFileId = fields.fileId.value && (content === null || content === void 0 ? void 0 : content.fileId) !== fields.fileId.value;
  var _useFetchFileStatus = useFetchFileStatus({
      fileId: fields.fileId.value,
      // Only poll file status if we have a file that is no longer uploading
      // and if the file is not already "ready" (meaning processing is complete) or invalid
      enabled: !hasFileStatusResolved,
      refetchInterval: 5000,
      // Delay value in milliseconds
      cancelFileNotificationOnSuccess: true // cancels the file notfication if the successfully fetched status is either Ready or Invalid
    }),
    fileStatus = _useFetchFileStatus.fileStatus;
  useEffect(function () {
    if (isChangedFileId) {
      setHasFileStatusResolved(fileStatus === FILE_STATUS_VALUES.READY || fileStatus === FILE_STATUS_VALUES.INVALID);
    }
  }, [fileStatus, isChangedFileId]);
  var isProcessingError = fileStatus === FILE_STATUS_VALUES.INVALID;

  // When editing an asset but not replacing the file, the processing status of the asset file is assumed to be complete,
  // as we do not want to show the Processing modal (again)
  var isProcessingComplete = isNewFile ? fileStatus === FILE_STATUS_VALUES.READY : true;
  var uploadNewFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var file, assetId, type, fileFormat, _yield$uploadFile, mainFileId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref2.file, assetId = _ref2.assetId, type = _ref2.type, fileFormat = _ref2.fileFormat;
            _context.next = 3;
            return uploadFile({
              file: file,
              // referenceId is required to start postprocessing
              referenceId: assetId,
              type: type,
              // Process videos as soon as possible but do not assign them to the asset yet
              // Skip assigning for any asset when in editmode, as we only want to assign the new file once the user has saved the changes
              skipAssigningToReference: isEditMode || fileFormat === FILE_FORMATS.VIDEO,
              notifyOnProcessingCompletion: true
            });
          case 3:
            _yield$uploadFile = _context.sent;
            mainFileId = _yield$uploadFile.fileId;
            // Set fileId once received from completed file upload
            fields.fileId.set(mainFileId);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function uploadNewFile(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var showUpdatedDetailsModal = function showUpdatedDetailsModal() {
    // Reset form to make sure we are using newest default values
    resetAssetEditorForm();
    // Close upload modal / replace file upload modal
    if (isReplacingFile) {
      setIsReplacingFile(false);
    }
    // Open Add details modal (depending on asset type)
    setView(VIEWS.DETAILS);
  };
  var uploadAssetFile = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
      var file, type, _getAssetType, customType, fileFormat, blob, durationInSec, durationInMin, fileNameOnly, draftAsset, _draftAsset$, id, parentId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            file = _ref4.file, type = _ref4.type;
            // Get customType and fileformat
            _getAssetType = getAssetType(file), customType = _getAssetType.customType, fileFormat = _getAssetType.fileFormat; // If we want to  document get read the text of the document
            if (fileFormat === FILE_FORMATS.PDF) {
              analyseResource(file);
            }

            // Get audio or video duration in min and set as default completionTime
            if (!fileFormatsWithDuration.some(function (format) {
              return format === fileFormat;
            })) {
              _context2.next = 18;
              break;
            }
            _context2.prev = 4;
            setIsLoadingDuration(true);
            blob = URL.createObjectURL(file);
            _context2.next = 9;
            return getBlobDuration(blob);
          case 9:
            durationInSec = _context2.sent;
            if (typeof durationInSec === 'number' && !Number.isNaN(durationInSec)) {
              durationInMin = Math.ceil(durationInSec / 60);
              setContent(function (prevContent) {
                return _objectSpread(_objectSpread({}, prevContent), {}, {
                  completionTime: durationInMin
                });
              });
            }
            _context2.next = 15;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](4);
          case 15:
            _context2.prev = 15;
            setIsLoadingDuration(false);
            return _context2.finish(15);
          case 18:
            if (!(content !== null && content !== void 0 && content.id)) {
              _context2.next = 24;
              break;
            }
            setContent(function (prevContent) {
              return _objectSpread(_objectSpread({}, prevContent), {}, {
                id: content.id,
                fileName: file.name,
                size: humanFileSize(file.size),
                type: type,
                customType: customType,
                fileFormat: fileFormat,
                fileId: null // When replacing a file, set  fileId to null until we receive the new fileId
              });
            });
            showUpdatedDetailsModal();
            uploadNewFile({
              file: file,
              assetId: content.id,
              type: type,
              fileFormat: fileFormat
            });
            _context2.next = 37;
            break;
          case 24:
            // Create a draft asset if no asset  was created  already
            fileNameOnly = removeFileType(file.name);
            _context2.prev = 25;
            _context2.next = 28;
            return createDraftAsset({
              type: type,
              name: fileNameOnly,
              ownerTeamId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.ownerTeamId
            });
          case 28:
            draftAsset = _context2.sent;
            _draftAsset$ = draftAsset[0], id = _draftAsset$.id, parentId = _draftAsset$.parentId; // Set asset content
            setContent(function (prevContent) {
              return _objectSpread(_objectSpread({}, prevContent), {}, {
                id: id,
                name: fields.name.value.trim().length ? fields.name.value : fileNameOnly,
                fileName: file.name,
                size: humanFileSize(file.size),
                type: type,
                customType: customType,
                fileFormat: fileFormat,
                parentId: parentId
              });
            });
            showUpdatedDetailsModal();
            uploadNewFile({
              file: file,
              assetId: id,
              type: type,
              fileFormat: fileFormat
            });
            _context2.next = 37;
            break;
          case 35:
            _context2.prev = 35;
            _context2.t1 = _context2["catch"](25);
          case 37:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 13, 15, 18], [25, 35]]);
    }));
    return function uploadAssetFile(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var stopFormSubmission = function stopFormSubmission() {
    setIsSubmissionLoading(false);
    setShouldAttemptSubmission(false);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setIsSubmissionLoading(true);
            setShouldAttemptSubmission(true);
            if (isUploadInProgress || !isProcessingComplete) {
              setIsProgressViewTriggered(true);
              setView(VIEWS.PROGRESS);
            }
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleSubmit() {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleClose = function handleClose() {
    // If an asset was being edited (not created) but no changes were made, no need to show the confirmation modal
    if (isEditMode && !form.wasChanged && !isUploadInProgress) {
      _onClose();
    } else {
      // When attempting the closing of the AssetEditor before completing asset creation
      // Stop any form submission (to prevent asset creation while attempting to close)
      // and open the confirmation modal
      stopFormSubmission();
      setView(VIEWS.CONFIRMATION);
    }
  };
  var handleUploadClose = function handleUploadClose() {
    stopFormSubmission();
    if (isProcessingError) {
      setView(VIEWS.UPLOAD);
    } else {
      setView(VIEWS.CONFIRMATION);
    }
  };
  var deleteAsset = function deleteAsset() {
    softDeleteAsset();
    _onClose();
  };

  // This function will only be called for newly uploaded assets.
  // Regular asset updates will be deferred to `onSubmit`
  var _useUpdateAssets = useUpdateAssets({
      assetIds: content !== null && content !== void 0 && content.id ? [content.id] : [],
      parentPlaylistId: inContentManagerContext ? undefined : parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
      hasSuccessAlert: false
    }),
    updateNewAsset = _useUpdateAssets.updateAssets;
  var submitRef = useCallbackRef(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _fields$name$changedV, _fields$description$v, _fields$externalRefId;
    var ownerTeamId, contentData, cleanedContentData, assetResponse, cleanedAssetResponse;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!isUploadError) {
            _context4.next = 3;
            break;
          }
          stopFormSubmission();
          return _context4.abrupt("return");
        case 3:
          if (hasPrivilege(ASSET_WRITE)) {
            // Admins with asset write privilege can change the owning team
            // (from the default "None")
            ownerTeamId = fields.ownerTeamId.changedValue;
          } else {
            // Users without asset write privilege can't change the owning team,
            // and the owning team of the parent playlist will be assigned
            ownerTeamId = isEditMode ? undefined : parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.ownerTeamId;
          }
          contentData = {
            // Add flag for setting asset to published when adding an asset
            published: isEditMode ? undefined : true,
            // We only set a fileId, when initially adding an asset or when replacing a file during asset editing
            fileId: fields.fileId.changedValue,
            ownerTeamId: ownerTeamId,
            parentId: fields.parentId.wasChanged ? fields.parentId.value : content === null || content === void 0 ? void 0 : content.parentId,
            name: (_fields$name$changedV = fields.name.changedValue) === null || _fields$name$changedV === void 0 ? void 0 : _fields$name$changedV.trim(),
            webUrl: fields.webUrl.changedValue,
            description: isEditMode ? fields.description.changedValue : (_fields$description$v = fields.description.value) === null || _fields$description$v === void 0 ? void 0 : _fields$description$v.trim(),
            locale: isEditMode ? fields.locale.changedValue :
            // When adding an asset, we want to save the default value if the locale wasn't changed
            fields.locale.value,
            tags: fields.tags.changedValue,
            thumbnailId: fields.thumbnailId.changedValue,
            customType: isEditMode ? fields.customType.wasChanged ||
            // This additional is required as when resetting the form during file upload, we  reset the customType,
            // as such customType.wasChanged would be false but we'd still want to use the new customType in the change of file type change
            (asset === null || asset === void 0 ? void 0 : asset.customType) !== (content === null || content === void 0 ? void 0 : content.customType) ? fields.customType.value : undefined :
            // When adding an asset, we want to save the default value if the customType wasn't changed
            fields.customType.value,
            fileFormat: isEditMode && asset && asset.fileFormat === (content === null || content === void 0 ? void 0 : content.fileFormat) ? undefined : content === null || content === void 0 ? void 0 : content.fileFormat,
            type: isEditMode && asset && asset.type === (content === null || content === void 0 ? void 0 : content.type) ? undefined : content === null || content === void 0 ? void 0 : content.type,
            completionTime: fields.completionTime.wasChanged ? Number(fields.completionTime.value) : undefined,
            download: fields.download.changedValue,
            markAsDoneMode: fields.markAsDoneMode.changedValue,
            alternativeText: fields.alternativeText.changedValue,
            openInIframe: IFRAME_CONTENT_TYPES.some(function (type) {
              return type === assetContentType;
            }) && (!isEditMode || fields.openInIframe.wasChanged) ? fields.openInIframe.value : undefined,
            subtitles: fields.subtitles.changedValue,
            scormSettings: fields.scormSettings.changedValue,
            externalRefId: fields.externalRefId.wasChanged ? ((_fields$externalRefId = fields.externalRefId.value) === null || _fields$externalRefId === void 0 ? void 0 : _fields$externalRefId.trim()) || null : undefined
          }; // ensure we only send the diff payload (do not send any undefined values)
          cleanedContentData = filterObject(contentData);
          if (isEditMode) {
            _context4.next = 17;
            break;
          }
          _context4.prev = 7;
          _context4.next = 10;
          return updateNewAsset(formatAssetEditorPayloadForApi({
            changes: cleanedContentData,
            parentPlaylistId: inContentManagerContext ? undefined : parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id
          }));
        case 10:
          assetResponse = _context4.sent;
          _context4.next = 17;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](7);
          setIsSubmissionLoading(false);
          return _context4.abrupt("return");
        case 17:
          cleanedAssetResponse = assetResponse ? filterObject(assetResponse) : undefined;
          _context4.prev = 18;
          _context4.next = 21;
          return onSubmit({
            changes: isEditMode ? cleanedContentData : cleanedAssetResponse,
            newContentId: !isEditMode ? content === null || content === void 0 ? void 0 : content.id : undefined
          });
        case 21:
          _context4.next = 26;
          break;
        case 23:
          _context4.prev = 23;
          _context4.t1 = _context4["catch"](18);
          setIsSubmissionLoading(false);
        case 26:
          if (isProgressViewTriggered) {
            // If the progress modal was open, we do not close the modal and instead show a "View in playlist" CTA
            setIsSubmissionLoading(false);
          } else {
            // Simply close AssetEditor if progress modal was not open
            _onClose();
          }
        case 27:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[7, 13], [18, 23]]);
  })));
  useEffect(function () {
    if (
    // We know the file upload is complete once we have a fileId for the uploaded file (and the uploadProgress is null)
    !isUploadInProgress && shouldAttemptSubmission && (
    // When replacing a file, wait until we have the new fileId
    // Attempt submission either if the asset is a web asset  or once the upload of the uploaded file is complete
    fields.fileId.value ||
    // Trigger submission regardless in case we are editing a weblink asset
    (content === null || content === void 0 ? void 0 : content.type) === CONTENT_TYPES.WEBLINK)) {
      submitRef.current();
    }
  }, [isUploadInProgress, fields.fileId.value, shouldAttemptSubmission, submitRef, content === null || content === void 0 ? void 0 : content.type]);
  useEffect(function () {
    // Open the replace modal in the case of an upload error or when triggering the replacement of the file
    if (isUploadError || isReplacingFile) {
      stopFormSubmission();
      setView(VIEWS.REPLACE);
    }
  }, [isReplacingFile, isUploadError]);
  useEffect(function () {
    // Open the replace modal in the case of an processing error while showing the Progress modal
    if (view === VIEWS.PROGRESS && isProcessingError) {
      stopFormSubmission();
      setView(VIEWS.REPLACE);
    }
  }, [isProcessingError, view]);
  var modals = (_modals = {}, _defineProperty(_modals, VIEWS.UPLOAD, /*#__PURE__*/React.createElement(NewFileModal, {
    isLoading: isCreating || isLoadingDuration,
    onClose: _onClose,
    onUploadAsset: uploadAssetFile,
    onSelectAsset: onSelectAsset,
    showSelectAsset: canUserSelectAsset
  })), _defineProperty(_modals, VIEWS.REPLACE, /*#__PURE__*/React.createElement(ReplaceFileModal, {
    isEditMode: isEditMode,
    isLoading: isCreating || isLoadingDuration,
    isUploadError: isUploadError,
    isProcessingError: isProcessingError,
    isReplacingFile: isReplacingFile,
    name: fields.name.value,
    oldAssetContentType: assetContentType,
    onUploadAsset: function onUploadAsset(_ref8) {
      var file = _ref8.file,
        type = _ref8.type;
      setIsNewFile(true);
      uploadAssetFile({
        file: file,
        type: type
      });
    },
    onDelete: deleteAsset,
    onClose: function onClose() {
      setIsReplacingFile(false);
      if (isProcessingError) {
        setView(VIEWS.CONFIRMATION);
      }
      // When attempting to edit an asset which has a processing error, we directly open the replace file modal.
      // If the user wants to close the replace modal without uploading a new file, simply close the modal
      else if (isEditMode && (asset === null || asset === void 0 ? void 0 : asset.fileStatus) === FILE_STATUS_VALUES.INVALID) {
        _onClose();
      } else if (isEditMode) {
        // If replace modal is closed in edit mode, we return to the previous view (either Details or Progress modal)
        setView(isProgressViewTriggered ? VIEWS.PROGRESS : VIEWS.DETAILS);
      } else {
        // If replace modal is closed during initial asset creation,
        // show confirmation modal to confirm canceling the asset creation
        setView(VIEWS.CONFIRMATION);
      }
    }
  })), _defineProperty(_modals, VIEWS.DETAILS, /*#__PURE__*/React.createElement(AssetDetailsModal, {
    inContentManagerContext: inContentManagerContext,
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    isLoading: isSubmissionLoading,
    isSubmitDisabled: form.hasErrors || isUploadError || isProcessingError || isEditMode && !form.wasChanged && !isUploadInProgress,
    showUploadProgress: isNewFile,
    fields: fields,
    uploadProgress: fileUploadProgress,
    assetContentType: assetContentType,
    content: content,
    aiSuggestions: aiSuggestions,
    onReplace: function onReplace() {
      setIsReplacingFile(true);
    },
    onDelete: deleteAsset,
    onSubmit: handleSubmit,
    onClose: handleClose,
    resetValues: resetAssetEditorForm,
    hasChanges: form.wasChanged
  })), _defineProperty(_modals, VIEWS.PROGRESS, /*#__PURE__*/React.createElement(UploadProgressModal, {
    isInProgress: isUploadInProgress || isSubmissionLoading,
    isProcessing: !isProcessingComplete,
    uploadProgress: fileUploadProgress,
    asset: {
      name: fields.name.value,
      thumbnailId: fields.thumbnailId.value,
      assetContentType: assetContentType,
      customType: fields.customType.value
    },
    onCancel: handleUploadClose,
    onClose: _onClose,
    onEdit: function onEdit() {
      setIsProgressViewTriggered(false);
      stopFormSubmission();
      setView(VIEWS.DETAILS);
    }
  })), _defineProperty(_modals, VIEWS.CONFIRMATION, /*#__PURE__*/React.createElement(ConfirmationModal, {
    isLoading: isDeleting,
    isEditMode: isEditMode
    // When within the "asset creation" flow, soft delete the asset when aborting the asset creation
    ,
    onConfirm: function onConfirm() {
      if (isEditMode) {
        _onClose();
      } else {
        deleteAsset();
      }
    },
    onCancel: function onCancel() {
      if (isProcessingError) {
        setView(VIEWS.REPLACE);
      } else {
        setView(isProgressViewTriggered ? VIEWS.PROGRESS : VIEWS.DETAILS);
      }
    }
  })), _modals);
  return modals[view];
}
export { formatAssetEditorPayloadForApi } from './formatAssetEditorPayloadForApi';
export default AssetEditor;